import ProfileManageAsideTabs from './ProfileManageAsideTabs';

export default ProfileManageAsideTabs;
